import { AccessorialCodeController } from './controller/AccessorialCodeController';
import { ActionLogController } from './controller/ActionLogController';
import { AiOrderEntryController } from './controller/AiOrderEntryController';
import { BillToController } from './controller/BillToController';
import { BrokerController } from './controller/BrokerController';
import { CarrierController } from './controller/CarrierController';
import { CarrierPortalController } from './controller/CarrierPortalController';
import { ClientController } from './controller/ClientController';
import { DashboardController } from './controller/DashboardController';
import { DockAppointmentController } from './controller/DockAppointmentController';
import { DocumentTemplateController } from './controller/DocumentTemplateController';
import { DomainController } from './controller/DomainController';
import { DomainPopulatorController } from './controller/DomainPopulatorController';
import { EquipmentTypeController } from './controller/EquipmentTypeController';
import { GeoCodingController } from './controller/GeoCodingController';
import { HandlingUnitController } from './controller/HandlingUnitController';
import { LocationGroupController } from './controller/LocationGroupController';
import { OrderBatchController } from './controller/OrderBatchController';
import { OrderCancellationReasonController } from './controller/OrderCancellationReasonController';
import { OrderCommentController } from './controller/OrderCommentController.ts';
import { OrderController } from './controller/OrderController';
import { OrderDocumentController } from './controller/OrderDocumentController';
import { OrderFreightAllowanceController } from './controller/OrderFreightAllowanceController';
import { OrderImportController } from './controller/OrderImportController';
import { OrderOrShipmentTemplateController } from './controller/OrderOrShipmentTemplateController';
import { OrderSavedSearchController } from './controller/OrderSavedSearchController';
import { OrderSearchController } from './controller/OrderSearchController.ts';
import { OrderSearchExportController } from './controller/OrderSearchExportController';
import { OrderTrackingLinkController } from './controller/OrderTrackingLinkController';
import { OrderTrackingLinkUnauthenticatedController } from './controller/OrderTrackingLinkUnauthenticatedController';
import { ProductController } from './controller/ProductController';
import { QuickQuoteController } from './controller/QuickQuoteController';
import { QuickSearchController } from './controller/QuickSearchController';
import { QuoteController } from './controller/QuoteController';
import { RateSelectionReasonController } from './controller/RateSelectionReasonTypeController';
import { ReferenceNumberTypeController } from './controller/ReferenceNumberTypeController';
import { RouteController } from './controller/RouteController';
import { RouteGeoJsonController } from './controller/RouteGeoJsonController';
import { RoutePlanController } from './controller/RoutePlanController.ts';
import { ServiceIncidentTypeController } from './controller/ServiceIncidentTypeController';
import { ServiceLevelController } from './controller/ServiceLevelController';
import { ShipmentBatchController } from './controller/ShipmentBatchController';
import { ShipmentBatchDocumentController } from './controller/ShipmentBatchDocumentController';
import { ShipmentBatchEventController } from './controller/ShipmentBatchEventController';
import { ShipmentCancellationReasonController } from './controller/ShipmentCancellationReasonController';
import { ShipmentCargoInsuranceController } from './controller/ShipmentCargoInsuranceController';
import { ShipmentCheckCallReminderController } from './controller/ShipmentCheckCallReminderController';
import { ShipmentCommentController } from './controller/ShipmentCommentController.ts';
import { ShipmentController } from './controller/ShipmentController';
import { ShipmentDocumentController } from './controller/ShipmentDocumentController';
import { ShipmentEventController } from './controller/ShipmentEventController';
import { ShipmentFinancialsController } from './controller/ShipmentFinancialsController';
import { ShipmentFreightAllowanceController } from './controller/ShipmentFreightAllowanceController.ts';
import { ShipmentLoadboardController } from './controller/ShipmentLoadboardController';
import { ShipmentManifestController } from './controller/ShipmentManifestController';
import { ShipmentParcelController } from './controller/ShipmentParcelController';
import { ShipmentPlanningConsolidationController } from './controller/ShipmentPlanningConsolidationController';
import { ShipmentPlanningController } from './controller/ShipmentPlanningController.ts';
import { ShipmentSavedSearchController } from './controller/ShipmentSavedSearchController';
import { ShipmentSearchController } from './controller/ShipmentSearchController';
import { ShipmentSearchExportController } from './controller/ShipmentSearchExportController';
import { ShipmentServiceIncidentController } from './controller/ShipmentServiceIncidentController';
import { ShipmentSpecController } from './controller/ShipmentSpecController';
import { ShipmentSpecLoadboardController } from './controller/ShipmentSpecLoadboardController';
import { ShipmentSpecSpotMarketBatchController } from './controller/ShipmentSpecSpotMarketBatchController';
import { ShipmentSpotMarketBatchController } from './controller/ShipmentSpotMarketBatchController';
import { ShipOrderController } from './controller/ShipOrderController';
import { ShippingPointController } from './controller/ShippingPointController';
import { SpotMarketRequestTemplateController } from './controller/SpotMarketRequestTemplateController';
import { StaticMapController } from './controller/StaticMapController';
import { TagController } from './controller/TagController';
import { UserController } from './controller/UserController';

export class Api {
  accessorialCode = new AccessorialCodeController();
  actionLog = new ActionLogController();
  aiOrderEntry = new AiOrderEntryController();
  billTo = new BillToController();
  broker = new BrokerController();
  carrier = new CarrierController();
  carrierPortal = new CarrierPortalController();
  client = new ClientController();
  dashboard = new DashboardController();
  dockAppointment = new DockAppointmentController();
  documentTemplate = new DocumentTemplateController();
  domain = new DomainController();
  domainPopulator = new DomainPopulatorController();
  equipmentType = new EquipmentTypeController();
  geoCoding = new GeoCodingController();
  handlingUnit = new HandlingUnitController();
  locationGroup = new LocationGroupController();
  shipmentLoadboard = new ShipmentLoadboardController();
  shipmentSpecLoadboard = new ShipmentSpecLoadboardController();
  order = new OrderController();
  orderBatch = new OrderBatchController();
  orderCancellationReason = new OrderCancellationReasonController();
  orderDocument = new OrderDocumentController();
  orderComment = new OrderCommentController();
  orderFreightAllowance = new OrderFreightAllowanceController();
  orderImport = new OrderImportController();
  orderOrShipmentTemplate = new OrderOrShipmentTemplateController();
  orderSavedSearch = new OrderSavedSearchController();
  orderSearch = new OrderSearchController();
  orderSearchExport = new OrderSearchExportController();
  orderTrackingLink = new OrderTrackingLinkController();
  orderTrackingLinkUnauthenticated =
    new OrderTrackingLinkUnauthenticatedController();
  product = new ProductController();
  quickQuote = new QuickQuoteController();
  quickSearch = new QuickSearchController();
  quote = new QuoteController();
  referenceNumberType = new ReferenceNumberTypeController();
  rateSelectionReason = new RateSelectionReasonController();
  route = new RouteController();
  routeGeoJson = new RouteGeoJsonController();
  routePlan = new RoutePlanController();
  serviceIncidentType = new ServiceIncidentTypeController();
  serviceLevel = new ServiceLevelController();
  shipOrder = new ShipOrderController();
  shipment = new ShipmentController();
  shipmentBatch = new ShipmentBatchController();
  shipmentBatchEvent = new ShipmentBatchEventController();
  shipmentCancellationReason = new ShipmentCancellationReasonController();
  shipmentCargoInsurance = new ShipmentCargoInsuranceController();
  shipmentCheckCallReminder = new ShipmentCheckCallReminderController();
  shipmentComment = new ShipmentCommentController();
  shipmentDocument = new ShipmentDocumentController();
  shipmentDocumentBatch = new ShipmentBatchDocumentController();
  shipmentEvent = new ShipmentEventController();
  shipmentFinancials = new ShipmentFinancialsController();
  shipmentFreightAllowance = new ShipmentFreightAllowanceController();
  shipmentManifest = new ShipmentManifestController();
  shipmentParcel = new ShipmentParcelController();
  shipmentPlanning = new ShipmentPlanningController();
  shipmentPlanningConsolidation = new ShipmentPlanningConsolidationController();
  shipmentSavedSearch = new ShipmentSavedSearchController();
  shipmentSearch = new ShipmentSearchController();
  shipmentSearchExport = new ShipmentSearchExportController();
  shipmentServiceIncident = new ShipmentServiceIncidentController();
  shipmentSpec = new ShipmentSpecController();
  shipmentSpecSpotMarketBatch = new ShipmentSpecSpotMarketBatchController();
  shipmentSpotMarketBatch = new ShipmentSpotMarketBatchController();
  shippingPoint = new ShippingPointController();
  spotMarketRequestTemplate = new SpotMarketRequestTemplateController();
  staticMap = new StaticMapController();
  tag = new TagController();
  user = new UserController();
}
